const SECTION_META = [
  ["marquee", "Editorial marquee ribbon"],
  ["problem", "Problem / manifesto chapters"],
  ["howItWorks", "How It Works (4 phases)"],
  ["platform", "Platform features (bento)"],
  ["comparison", "Comparison table"],
  ["pricing", "Pricing"],
  ["testimonials", "Client stories"],
  ["trust", "Trust & compliance"],
  ["brandBand", "Brand band (full logo)"],
  ["quote", "Quote form CTA"],
];

export function SectionsToggles({ doc, setDoc }) {
  const sections = doc.sections || {};
  const options = doc.options || {};
  const toggle = (key) =>
    setDoc({ ...doc, sections: { ...sections, [key]: !sections[key] } });
  const toggleOption = (key) =>
    setDoc({ ...doc, options: { ...options, [key]: !options[key] } });

  const switchCls = (on) =>
    `relative h-6 w-11 shrink-0 rounded-full transition-colors duration-200 ${on ? "bg-aqua-600" : "bg-slate-300"}`;
  const knobCls = (on) =>
    `absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition-[left] duration-200 ${on ? "left-[22px]" : "left-0.5"}`;

  return (
    <div data-testid="admin-sections-toggles">
      <h1 className="mb-2 font-display text-2xl font-semibold">Sections</h1>
      <p className="mb-6 text-sm text-slate-500">
        Show or hide entire sections of the site. The hero, header, and footer always stay visible.
      </p>
      <div className="grid gap-3 md:grid-cols-2">
        {SECTION_META.map(([key, label]) => {
          const on = sections[key] !== false;
          return (
            <button
              key={key}
              data-testid={`admin-section-toggle-${key}`}
              onClick={() => toggle(key)}
              className={`flex items-center justify-between rounded-2xl border p-4 text-left transition-colors duration-200 ${
                on ? "border-aqua-600/30 bg-aqua-600/[0.04]" : "border-slate-200 bg-slate-50"
              }`}
            >
              <div>
                <div className="text-sm font-bold text-ink">{label}</div>
                <div className="text-xs text-slate-400">{on ? "Visible on site" : "Hidden from site"}</div>
              </div>
              <span className={switchCls(on)}>
                <span className={knobCls(on)} />
              </span>
            </button>
          );
        })}
      </div>

      <h2 className="mb-2 mt-10 font-display text-2xl font-semibold">Behaviour</h2>
      <p className="mb-6 text-sm text-slate-500">Fine-tune how the site greets visitors.</p>
      <button
        data-testid="admin-option-skip-intro"
        onClick={() => toggleOption("skipIntroReturning")}
        className={`flex w-full items-center justify-between rounded-2xl border p-4 text-left transition-colors duration-200 md:max-w-xl ${
          options.skipIntroReturning ? "border-aqua-600/30 bg-aqua-600/[0.04]" : "border-slate-200 bg-slate-50"
        }`}
      >
        <div>
          <div className="text-sm font-bold text-ink">Skip intro for returning visitors</div>
          <div className="text-xs text-slate-400">
            {options.skipIntroReturning
              ? "Returning visitors go straight to the site — no logo intro"
              : "Everyone sees the logo intro on every visit"}
          </div>
        </div>
        <span className={switchCls(!!options.skipIntroReturning)}>
          <span className={knobCls(!!options.skipIntroReturning)} />
        </span>
      </button>
    </div>
  );
}
